import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface OptionButtonProps {
  children: ReactNode;
  icon?: ReactNode;
  selected?: boolean;
  onClick: () => void;
  className?: string;
}

export const OptionButton = ({ 
  children, 
  icon, 
  selected = false, 
  onClick, 
  className = "" 
}: OptionButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full p-3 md:p-4 rounded-xl border-2 transition-all duration-200 text-left group hover:scale-[1.02] hover:shadow-button",
        selected 
          ? "border-primary bg-primary/5 shadow-button" 
          : "border-border bg-card hover:border-primary/50",
        className
      )}
    >
      <div className="flex items-center gap-2 md:gap-3">
        {icon && (
          <div className={cn(
            "flex-shrink-0 p-1.5 md:p-2 rounded-lg transition-colors",
            selected 
              ? "bg-primary text-primary-foreground" 
              : "bg-secondary text-muted-foreground group-hover:bg-primary/10 group-hover:text-primary"
          )}>
            {icon}
          </div>
        )}
        <span className={cn(
          "text-sm md:text-base font-medium transition-colors",
          selected ? "text-primary" : "text-foreground"
        )}>
          {children}
        </span>
      </div>
    </button>
  );
};